import React from 'react';
import {
  useReactTable,
  flexRender,
  getCoreRowModel,
  ColumnDef,
} from '@tanstack/react-table';
import { RecommendationTableRow } from '../types';

type PlanTableProps = {
  columns: ColumnDef<RecommendationTableRow>[];
  data: RecommendationTableRow[];
  handleRowSelection?: (id: string) => void;
};

export function PlanTable({ columns, data, handleRowSelection }: PlanTableProps) {
  const baseString = 'plan-table';
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <table className={baseString} data-test-id={baseString}>
      <thead>
        {table.getHeaderGroups().map((hg) => (
          <tr key={hg.id}>
            {hg.headers.map((header) => (
              <th key={header.id} data-test-id={`header-${header.id}`}>
                {flexRender(
                  header.column.columnDef.header,
                  header.getContext()
                )}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody>
        {table.getRowModel().rows.map((row) => (
          <tr
            key={row.id}
            data-row-selected={!!row?.original?.isRowSelected}
            onClick={() => handleRowSelection?.(row.original.id)}
          >
            {row.getVisibleCells().map((cell) => (
              <td key={cell.id} data-test-id={`cell-${cell.id}`}>
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
